import request from '../http/index'

/**********日常工作->学术活动->活动档案**********/

/**
 * 列表
 * @param {*} data
 * @returns
 */
export async function ActivityList(data = {}) {
	const res = await request.post("/api/ba/Activity/List", data);
	return res.data;
}

/**
 * 明细
 * @param {*} data
 * @returns
 */
export async function ActivityDetail(data = {}) {
	const res = await request.post("/api/ba/Activity/Detail", data);
	return res.data;
}

/**
 * 查看/详情
 * @param {*} data
 * @returns
 */
export async function ActivityInfo(data = {}) {
	const res = await request.post("/api/ba/Activity/Info", data);
	return res.data;
}

/**
 * 导出
 * @param {*} data
 * @returns
 */
export async function ActivityExport(data = {}) {
	const res = await request.post("/api/ba/Activity/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 * 导入
 * @param {*} data
 * @returns
 */
export async function ActivityImport(data = {}) {
	const res = await request.post("/api/ba/Activity/Import", data);
	return res.data;
}

/**
 * 导入模板下载
 * @param {*} data
 * @returns
 */
export async function ActivityDownloadTemplet(data = {}) {
	const res = await request.post("/api/ba/Activity/DownloadTemplet", data);
	return res.data;
}

/**
 * 新增
 * @param {*} data
 * @returns
 */
export async function ActivityAdd(data = {}) {
	const res = await request.post("/api/ba/Activity/Add", data);
	return res.data;
}

/**
 * 修改
 * @param {*} data
 * @returns
 */
export async function ActivityEdit(data = {}) {
	const res = await request.post("/api/ba/Activity/Edit", data);
	return res.data;
}

/**
 * 删除
 * @param {*} data
 * @returns
 */
export async function ActivityDelete(data = {}) {
	const res = await request.post("/api/ba/Activity/Delete", data);
	return res.data;
}

/**
 * 举办活动
 * @param {*} data
 * @returns
 */
export async function ActivityRecordAdd(data = {}) {
	const res = await request.post("/api/ba/ActivityRecord/Add", data);
	return res.data;
}

// Helpers

/**
 * 会议类型(L2)下拉
 * @param {*} data {InvClass: "产品线"}
 * @returns
 */
export async function HelperLEVEL2ForItem(data = {}) {
	const res = await request.post("/api/helper/Helper/LEVEL2ForItem", data);
	return res.data;
}

/**
 * 入院状态下拉
 * @param {*} data
 * @returns
 */
export async function HelperInHospitalStatus(data = {}) {
	const res = await request.post("/api/helper/Helper/InHospitalStatus", data);
	return res.data;
}

/**
 * 重点产品(L3)下拉
 * @param {*} data {InvClass: "产品线"}
 * @returns
 */
export async function HelperLEVEL3ForItem(data = {}) {
	const res = await request.post("/api/helper/Helper/LEVEL3ForItem", data);
	return res.data;
}

/**
 * 活动目标下拉
 * @param {*} data
 * @returns
 */
export async function HelperActivityPurpos(data = {}) {
	const res = await request.get("/api/helper/Helper/ActivityPurpose", data);
	return res.data;
}